import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { TxSelectors } from "src/redux/Tx/selectors";
import { TxActions } from "src/redux/Tx/actions";
import { TX_INIT_ERROR_MESSAGES } from "src/redux/Tx/constants";
import { Tx } from "src/redux/Tx/types";
import {
    getFromLocalUserStorage,
    saveLocalUserStorage,
} from "src/utils/localStorage";

import styles from "./styles.module.scss";

export default ({ on, type }) => {
    const ac = getFromLocalUserStorage(Tx.AC_STORAGE_VALUE);
    const previewErrors = useSelector(TxSelectors.TxInitErrors);
    const previewDisables = useSelector(TxSelectors.TxInitDisables);

    const [minQuantityPercent, setMinQuantityPercent] = useState(
        ac.minQuantityPercent
    );
    const [maxRateBps, setMaxRateBps] = useState(ac.maxRateBps);
    const [maxDiv, setMaxDiv] = useState(ac.maxDiv);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!on) return;
        const newAC = {
            minQuantityPercent,
            maxRateBps,
            /* because maxDiv is a float and we dont want to use input[type="number"]
             * we dont get very good validation parseFloat("1234.") === 1234 so the decimal
             * point disappeares. also to ensure its a float and not a string parseFloat twice*/
            maxDiv: parseFloat(parseFloat(maxDiv).toFixed(2)),
        };

        saveLocalUserStorage(Tx.AC_STORAGE_VALUE, newAC);
        dispatch(TxActions.UpdateAC(on, newAC, type));
    }, [on, minQuantityPercent, maxRateBps, maxDiv, dispatch]);

    const disableBps =
        previewDisables.includes("maxRateBps") && styles.disabled;

    return (
        <div className={`${styles.acceptanceCriteria}`}>
            <Section
                className={
                    previewErrors.includes("minQuantityPercent")
                        ? [styles.error]
                        : []
                }
            >
                <label>
                    <div className={styles.inputTitle}>
                        <div className={styles.titleLong}>
                            Acceptable Min Qty
                        </div>
                        <div>&#61;</div>
                        <div className={styles.titleCenter}>My Qty</div>
                        <div>&#215;</div>
                    </div>
                    <input
                        data-testid="ac-qty"
                        value={minQuantityPercent}
                        onChange={(e) =>
                            !isNaN(e.target.value) &&
                            setMinQuantityPercent(e.target.value)
                        } //TODO Validate this properly
                        disabled={!on}
                    />
                    <div className={styles.unit}>%</div>
                </label>
                {previewErrors.includes("minQuantityPercent") && (
                    <div
                        data-testid="ac-qty-error"
                        className={styles.errorMessage}
                    >
                        <span>{TX_INIT_ERROR_MESSAGES.minQuantityPercent}</span>
                    </div>
                )}
            </Section>

            <Section
                className={
                    previewErrors.includes("maxRateBps")
                        ? [styles.error, disableBps]
                        : [disableBps]
                }
            >
                <label aria-disabled={disableBps}>
                    <div className={styles.inputTitle}>
                        <div className={styles.titleLong}>
                            Acceptable Max Rate
                        </div>
                        <div>&#61;</div>
                        <div className={styles.titleCenter}>My Rate</div>
                        <div>&#43;</div>
                    </div>
                    <input
                        data-testid="ac-rate"
                        value={maxRateBps}
                        onChange={(e) => {
                            const num = parseInt(e.target.value); // NaN if blank or spaces
                            setMaxRateBps(isNaN(num) ? "" : num);
                        }} //TODO Validate this properly
                        disabled={!on || previewDisables.includes("maxRateBps")}
                    />
                    <div className={styles.unit}>bps</div>
                </label>
                {previewErrors.includes("maxRateBps") && (
                    <div
                        data-testid="ac-rate-error"
                        className={styles.errorMessage}
                    >
                        <span>{TX_INIT_ERROR_MESSAGES.maxRateBps}</span>
                    </div>
                )}
            </Section>

            <Section
                className={
                    previewErrors.includes("maxDiv") ? [styles.error] : []
                }
            >
                <label>
                    <div className={styles.inputTitle}>
                        <div>Max Div Liability</div>
                        <div>&#61;</div>
                    </div>
                    <input
                        data-testid="ac-div"
                        value={maxDiv}
                        onChange={(e) =>
                            !isNaN(e.target.value) && setMaxDiv(e.target.value)
                        }
                        disabled={!on}
                    />
                    <div className={styles.unit}>%</div>
                </label>
                {previewErrors.includes("maxDiv") && (
                    <div
                        data-testid="ac-div-error"
                        className={styles.errorMessage}
                    >
                        <span>{TX_INIT_ERROR_MESSAGES.dividend}</span>
                    </div>
                )}
            </Section>
            {/*<Section className={styles.preferredType}>*/}
            {/*    <span>Preferred Loan Type :</span>*/}
            {/*    <RadioButtons*/}
            {/*        options={LOAN_TYPE_OPTIONS}*/}
            {/*        dataTestId="tx-request-select-accept-loan-type"*/}
            {/*        value={preferredType}*/}
            {/*        setter={(v) => setPreferredType(v)}*/}
            {/*    />*/}
            {/*</Section>*/}
        </div>
    );
};

const Section = ({ className, children }) => (
    <div
        className={[styles.section, styles.clearfix]
            .concat(className || [])
            .join(" ")}
    >
        <div className={styles.input}>{children}</div>
    </div>
);
